import React from 'react';
import { Sparkle } from 'phosphor-react';
import { PrimaryButton } from '../index';

interface SuccessScreenProps {
  completedCount: number;
  total: number;
  navigate: (path: string) => void;
}

export default function SuccessScreen({ completedCount, total, navigate }: SuccessScreenProps) {
  return (
    // Tela rara e comemorativa: aqui a entrada escalonada tem função (guiar o olho
    // do selo para o número e daí para o botão), ao contrário do resto do app.
    <div className="stagger min-h-screen bg-cream dark:bg-gray-950 flex flex-col items-center justify-center px-6 text-center transition-colors">
      <div className="w-24 h-24 rounded-full bg-sage-100 dark:bg-sage-900/30 flex items-center justify-center mb-6">
        <Sparkle className="w-12 h-12 text-sage-500" />
      </div>
      <h2 className="text-2xl font-bold text-gray-800 dark:text-gray-100">Rotina concluída!</h2>
      <p className="text-sm text-nude-500 dark:text-gray-400 mt-2">
        Você completou <span className="font-semibold text-sage-600">{completedCount}</span> de{' '}
        <span className="font-semibold">{total}</span> etapas.
      </p>
      <p className="text-xs text-nude-400 dark:text-gray-500 mt-1">
        O progresso foi registrado no seu histórico.
      </p>
      <div className="mt-8 w-full max-w-xs flex flex-col gap-3">
        <PrimaryButton fullWidth onClick={() => navigate('/dashboard')}>
          Voltar ao início
        </PrimaryButton>
        <button
          onClick={() => navigate('/progress/history')}
          className="text-sm text-blush-400 hover:text-blush-600 font-medium transition-colors"
        >
          Ver histórico de progresso
        </button>
      </div>
    </div>
  );
}
